import React from 'react';
import PercentageNumber from '../formatting/PercentageNumber';
import { TextField } from '@material-ui/core';

const PercentageTextField = (props) => <TextField {...props} InputProps={{ inputComponent: PercentageNumber }} />;

export default PercentageTextField;



// WEBPACK FOOTER //
// ./src/core/text-fields/PercentageTextField.jsx